'use client'

import { useId } from 'react'

// The 12-point starburst used for the Green Tick badge (shown next to a @username).
const BURST_PATH =
  'M12 2l1.7 1.8 2.4-.4.9 2.3 2.4.8-.2 2.5 1.8 1.7-1.3 2.1.8 2.4-2.1 1.2-.4 2.5-2.5-.2-1.7 1.8-2.1-1.3-2.4.8-1.2-2.1-2.5-.4.2-2.5-1.8-1.7 1.3-2.1-.8-2.4 2.1-1.2.4-2.5 2.5.2z'

/**
 * Green Tick badge - calm emerald starburst with a white check (no glow, no animation).
 * Every instance gets its own gradient/clip ids so many ticks can sit on one page.
 */
export function GreenTick({ size = 19, title = 'Green Tick' }: { size?: number; title?: string }) {
  const uid = useId().replace(/[^a-zA-Z0-9]/g, '')
  const gradId = `gt-grad-${uid}`
  return (
    <span className="green-tick" role="img" aria-label={title} title={title} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#34D399" />
            <stop offset="50%" stopColor="#10B981" />
            <stop offset="100%" stopColor="#059669" />
          </linearGradient>
        </defs>
        <path d={BURST_PATH} fill={`url(#${gradId})`} />
        <path d="M9.2 12l2 2 3.8-3.8" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  )
}
